/**
 * R:SPORT Bundle Logic - FINAL UPDATED 2026
 * - סכום דינמי
 * - נעילת רקע וסליידר פנימי (במחשב בלבד)
 * - רענון דף והודעת הצלחה (Toast)
 * - חסימת פריטים שכבר בעגלה
 */
document.addEventListener('DOMContentLoaded', function() {
    const bundleList = document.getElementById('bundle-list');
    const overlay = document.getElementById('bundle-overlay');
    const toggleBtn = document.getElementById('toggle-bundle');
    const imagesToggle = document.getElementById('images-toggle');
    const closeBtn = document.getElementById('close-drawer');
    const addBtn = document.getElementById('add-rsport-bundle');

    // הפונקציה שמציגה הודעות קופצות במרכז המסך
    function showRsportMessage(text) {
        let toast = document.querySelector('.rsport-toast');
        if (!toast) {
            toast = document.createElement('div');
            toast.className = 'rsport-toast';
            document.body.appendChild(toast);
        }
        toast.textContent = text;
        toast.classList.add('active');
        setTimeout(() => toast.classList.remove('active'), 3500); 
    }

    // --- 1. בדיקה אוטומטית ברענון הדף (הודעת הצלחה) ---
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('bundle_added') === 'true') {
        showRsportMessage('הפריטים נוספו לעגלה בהצלחה!');
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    // --- 2. מניעת בחירה כפולה (Cart Lock) ---
    function lockItemsAlreadyInCart() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const itemsInCart = cart.items.map(item => item.variant_id.toString());
                const rows = document.querySelectorAll('.bundle-row-wrapper');

                rows.forEach(row => {
                    const checkbox = row.querySelector('.rsport-bundle-check');
                    const select = row.querySelector('.bundle-variant-select');
                    
                    if (checkbox) {
                        const currentVariantId = select ? (select.value || select.getAttribute('value')) : null;

                        if (currentVariantId && itemsInCart.includes(currentVariantId)) {
                            checkbox.disabled = true; 
                            checkbox.checked = false; 
                            checkbox.setAttribute('data-locked-cart', 'true');
                        } else {
                            checkbox.disabled = false;
                            checkbox.removeAttribute('data-locked-cart');
                        }
                    }
                });
                
                updateTotalPrice();
            })
            .catch(error => console.error('Error fetching cart:', error));
    }

    lockItemsAlreadyInCart();

    const variantSelects = document.querySelectorAll('.bundle-variant-select');
    variantSelects.forEach(select => {
        if (select.tagName === 'SELECT') {
            select.addEventListener('change', function() {
                lockItemsAlreadyInCart(); 
            });
        }
    });

    // התראה כשלוחצים על פריט שכבר בעגלה
    document.addEventListener('click', function(e) {
        const actionWrapper = e.target.closest('.upsell-action');
        if (actionWrapper) {
            const checkbox = actionWrapper.querySelector('.rsport-bundle-check');
            if (checkbox && checkbox.getAttribute('data-locked-cart') === 'true') {
                showRsportMessage('המידה שבחרת כבר נוספה בהצלחה לסל');
            }
        }
    });

    // --- 3. פונקציית עזר להצגת סכום כולל ---
    function updateTotalPrice() {
        let total = 0;
        const rows = document.querySelectorAll('.bundle-row-wrapper');
        let totalContainer = document.getElementById('bundle-total-price-display');
        
        if (!totalContainer) {
            totalContainer = document.createElement('div');
            totalContainer.id = 'bundle-total-price-display';
            addBtn.parentNode.insertBefore(totalContainer, addBtn);
        }

        rows.forEach(row => {
            const checkbox = row.querySelector('.rsport-bundle-check');
            if (checkbox && checkbox.checked && !checkbox.disabled) {
                const priceText = row.querySelector('.current-price').textContent;
                const priceValue = parseFloat(priceText.replace(/[^\d.]/g, ''));
                total += priceValue;
            }
        });

        if (total > 0) {
            totalContainer.innerHTML = `<span>סה"כ לתשלום:</span> <strong>₪${total.toFixed(2)}</strong>`;
            totalContainer.style.display = 'flex';
        } else {
            totalContainer.style.display = 'none';
        }
    }

    document.addEventListener('change', function(e) {
        if (e.target.classList.contains('rsport-bundle-check')) {
            updateTotalPrice();
        }
    });

    // --- 4. פתיחת וסגירת מגירה עם נעילת רקע למחשב בלבד ---
    function openDrawer(e) {
        if(e) e.preventDefault();
        bundleList.classList.add('active');
        overlay.classList.add('active');
        
        // נועל את הרקע ומאפשר סליידר רק אם זה לא מובייל
        if (window.innerWidth > 767) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        }
        document.body.classList.add('stop-scrolling');
        
        updateTotalPrice(); 
    }

    function closeDrawer() {
        bundleList.classList.remove('active');
        overlay.classList.remove('active');
        
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('stop-scrolling');
    }

    if(toggleBtn) toggleBtn.addEventListener('click', openDrawer);
    if(imagesToggle) imagesToggle.addEventListener('click', openDrawer);
    if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if(overlay) overlay.addEventListener('click', closeDrawer);

    // --- 5. הוספה לסל ורענון ---
    if(addBtn) {
        addBtn.addEventListener('click', function() {
            let items = [];
            let missingSize = false;
            const rows = document.querySelectorAll('.bundle-row-wrapper');
            
            rows.forEach(row => {
                const checkbox = row.querySelector('.rsport-bundle-check');
                const select = row.querySelector('.bundle-variant-select');
                
                if(checkbox && checkbox.checked && !checkbox.disabled) {
                    const variantId = select ? select.value : (row.querySelector('input[type="hidden"]') ? row.querySelector('input[type="hidden"]').value : null);
                    if(!variantId || variantId === "") {
                        missingSize = true;
                    } else {
                        items.push({ id: parseInt(variantId), quantity: 1 });
                    }
                }
            });

            if(items.length === 0) {
                showRsportMessage('אנא בחר לפחות פריט אחד מהרשימה');
                return;
            }

            if(missingSize) {
                showRsportMessage('חובה לבחור מידה עבור הפריטים שסימנת');
                return;
            }

            const originalText = addBtn.textContent;
            addBtn.textContent = 'מעדכן סל...';
            addBtn.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            })
            .then(res => res.json())
            .then(data => {
                // רענון העמוד מיד לאחר ההוספה לעגלה, עם פרמטר להודעת הצלחה
                window.location.href = window.location.pathname + '?bundle_added=true';
            })
            .catch(err => {
                showRsportMessage('שגיאה בתקשורת');
                addBtn.disabled = false;
                addBtn.textContent = originalText;
            });
        });
    }
});